<template lang="pug">
.pop-more(:style="showOperation==true ? '' : 'display:none' " )
    div(:class="'van-popup ' + popType " @click="$emit('operationEvent' , {display:false , event : $event})" )
        .mlist(v-if="popType=='operation'")
            .item(@click="$emit('fatherMethod', {method:'viewOwner',data:true,addOnMethods:['goToComment']})")
                i.iconfont.icon-home
                template 只看楼主
            .item(@click="$emit('fatherMethod', {method:'share',data:null})")
                i.iconfont.icon-share
                template 分享
            .item(@click="$emit('fatherMethod', 'showArticleReport')")
                i.iconfont.icon-report-sign
                template 举报

        .report(v-if="popType=='report'")

            .item(v-for="(item,key) in reportTypes" :key="key" @click="doReport(key)")
                span.text {{item}}
                span.check
                    i.iconfont.icon-checked
            .item.cancel(@click="$emit('operationEvent' , false)") 取消

        .pager-list(v-if="popType=='pager'")
            .item(v-for="(item,key) in popData" :key="key" @click="$emit('fatherMethod',{method:'loadPage',data:key,addOnMethods:['goToComment']})")
                span.text {{item}}
        .manage(v-if="popType=='manage'")
            .items
                a(@click="manage.active='setTop'" :class="manage.active=='setTop' ? 'active' :'' " ) 置顶
                a(@click="setPopular")  加精
                a(@click="setVisible")  作者可见
                a(@click="edit")  修改
                a(:class="manage.active=='deeletdelete' ? 'active' :'' " @click="setDelete")  删除
                a(:class="manage.active=='banAccount' ? 'active' :'' " @click="manage.active='banAccount'")  封号
                a(@click="emptyUserData")  清空帖子
            .area
                .form(v-if="manage.active == 'setTop'")
                    .row
                        .txt 帖子主题
                        .info {{popData.article.title}}
                    .row
                        .txt 置顶范围
                        .info
                            select(v-model="mForm.setTopCate")
                                option(v-for="(item,key) in data.menu" :key="key" :value="key") {{item.name}}
                            select(v-model="mForm.top")
                                option(v-for="(item) in data.menu[mForm.setTopCate].child" :value="item.value") {{item.name}}
                    .row
                        .txt 有效期
                        .info
                            input(v-model="mForm.top_start_time" type="date")
                            input(v-model="mForm.top_end_time" type="date")
                    .row
                        .txt 操作原因
                        .info
                            textarea.reason(v-model="mForm.reason")

                .form(v-if="manage.active=='banAccount'")
                    .row 对用户 {{popData.article.username}} 进行封号
                    .row
                        .txt 封号到:
                        .info
                            input(v-model="banForm.toDate" type="date")
                    .row
                        .txt 操作原因
                        .info
                            textarea.reason(v-model="banForm.reason")
                .row
                    button.ok(@click="saveManage") 确定
                    button(@click="$emit('operationEvent' , {display:false})") 取消
                .info
                    .row 仅作者可见：{{popData.article.view_access == '0' ? '否' : '是' }}
</template>

<script>
    import appHelper from "../lib/appHelper"
    import $ from "jquery";
    import utils from "../lib/util"

    export default {
        name: 'moreTab',
        props : {
            data : Object,
            popType : String,
            popData : Object,
            showOperation : Boolean
        },
        mounted : function(){
        },
        beforeMount : function(){
            //console.log(unescape(this.data.topUrl));
            //&amp;
            this.data.topUrl = this.data.topUrl.replace(/&amp;/g , '&');
            this.data.creamUrl = this.data.creamUrl.replace(/&amp;/g , '&');
            this.data.deleteUrl = this.data.deleteUrl.replace(/&amp;/g , '&');
        },
        data : function(){
            return {
                fData : this.data,
                reportTypes : {
                    1   : "营销广告",
                    2   : "淫秽色情",
                    3   : "地域攻击",
                    4   : "恶意谩骂",
                    5   : "其他",
                },
                manage : {
                    active : 'setTop',
                },

                mForm : {
                    setTopCate : 0,
                    top : 0,            //置顶id
                    top_start_time : '',
                    top_end_time : '',
                    reason : ''
                },
                banForm : {
                    reason : '',
                    toDate : ''
                }
            }
        },
        move : function(){
            return true;
        },
        methods : {

            doReport : function(reportType){
                //haha
                console.log(this.popData);
                let tData = this.popData;
                let rType = tData.type == 'post' ? 2 : 1;
                alert("举报成功，我们将进行相关核实！非常感谢您的举报！");
                //不对结果进行判断
                $.getJSON(`/v1.0/report/report.html?type=${rType}&infoId=${tData.infoid}&reportType=${reportType}`);
                this.$emit('operationEvent' , false);
            },

            saveManage :  function(){
                let query = '';
                if (this.manage.active == 'setTop'){
                    // query = qs.stringify(this.mForm);
                    query = utils.buildQuery(this.mForm);
                    $.getJSON(this.data.topUrl + `&oper=1&${query}`,function(data){
                        alert(data.msg);
                    });
                } else if( this.manage.active == 'banAccount' ){

                    if (this.banForm.toDate == ''){
                        alert('请选择到期时间！');return;
                    }
                    let arr = this.banForm.toDate.split('-');
                    let date = new Date(arr[0] , arr[1] , arr[2]);
                    console.log(date.valueOf());

                    let stamp = Math.floor(date.valueOf()/1000);

                    $.post("/article-manager/user-banned.html",{
                        msg : this.banForm.reason,
                        uid : this.popData.article.uid,
                        date : stamp
                    },function(data){
                        if (data.type != 'succ'){
                            alert(data.msg);return;
                        }
                        alert(data.msg);
                    },'JSON');
                }
            },

            setDelete : function(){
                if (!confirm('确定删除帖子吗？')){
                    return false  ;
                }
                $.getJSON(this.data.deleteUrl,function(rep){
                    alert(rep.msg);
                });

            },
            setPopular : function(){
                if (!confirm('确定加精帖子吗？')){
                    return false  ;
                }
                $.getJSON(this.data.creamUrl + "&cream=1&oper=1",function(rep){
                    alert(rep.msg);
                });
            },
            setVisible:function(){
                console.log(this.popData.article);
                let zuozhekejian = decodeURI('%E4%BB%85%E4%BD%9C%E8%80%85%E5%8F%AF%E8%A7%81');
                let tips = "确定将本文【 设置 】为" + zuozhekejian + "?";
                let doType = 1;
                if (this.popData.article.view_access == '1'){
                    tips = "确定  【取消】  本文的 【"+zuozhekejian+"】？" ;
                    doType = 0;
                }
                if (!confirm(tips)){
                    return ;
                }

                $.getJSON(`/article-manager/set-view-access.html?article=${this.popData.article.id}&type=${doType}`,function(data){
                    if (data.type == 'succ'){
                        location.reload();
                        return;
                    }
                    alert(data.msg);
                })
            },

            emptyUserData : function(){
                ///article-manager/clear-user.html?uid=12

                //您确定清空该用户所有发帖？
                if (!confirm(decodeURI('%E6%82%A8%E7%A1%AE%E5%AE%9A%E6%B8%85%E7%A9%BA%E8%AF%A5%E7%94%A8%E6%88%B7%E6%89%80%E6%9C%89%E5%8F%91%E5%B8%96%EF%BC%9F'))){
                    return ;
                }

                $.getJSON(`/article-manager/clear-user.html?uid=${this.popData.article.uid}`,function(data){
                    if (data.type == 'succ'){
                        location.reload();
                        return;
                    }
                    alert(data.msg);
                })
            },
            edit : function(){
                let json = JSON.stringify({
                    type : "edit",
                    id : this.popData.article.id
                });
                appHelper.pipe("openWindow",['postCircle',json]);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .pop-more{
        .pager{
            top: 50px!important;
        }
    }
.van-popup{
    position: fixed;
    transform: translateZ(0);
    width: 100%;
    height: 100%;
    z-index: 2002;
    top:0px;
    background: #00000077;


    .item{
        height: 50px;
        line-height: 50px;
        border-bottom: 1px #eee solid;
        text-indent: 25px;
    }
    .mlist{
        background: #fff;
        margin: 0px auto;
        width: 60%;
        height:155px;margin-top: 45%;
        i{
            margin-right: 15px;
        }
        &div:last-child{
            border-bottom: none!important;
        }
    }
    .pager-list{
        background: #fff;
        border-top: 1px #eee solid;
        max-height: 400px;
        overflow-y: scroll;
    }
    .report{
        background: #fff;
        bottom:0px;
        width: 100%;
        position: absolute;
        .cancel{
            justify-content: center;
            text-indent: 0px;
        }
        .item{
            display: flex;
            .check{
                text-indent: 0px;
                height: 20px;
                width: 20px;
                border-radius: 50%;
                border:2px #ddd solid;
                background: #fff;
                line-height: 19px;
                margin-right: 10px;
                margin-top: 16px;
                text-align: center;
                i{
                    font-size: 12px;
                    display: none;
                }
            }
            .text{
                flex-grow: 1;
            }
        }
        div.active{
            .check{
                background:#44b05a;;
                color: #fff;
                border:2px #44b05a solid;
                i{
                    display: block;
                }
            }
        }
    }

    .manage{
        border:1px #ddd solid;
        background: #fff;
        .items{
            display: flex;
            flex-wrap: wrap;
            a{
                flex-basis: 25%;
                height: 30px;
                line-height: 30px;
                text-align: center;
                &.active{
                    border-bottom: 1px #0CB25E solid;
                    color: #0CB25E;
                }
            }
        }
        .area{
            padding-top: 15px;
            .row{
                display: flex;
                flex-wrap:nowrap;
                padding: 10px;
                .txt{
                    width: 80px;
                }
                .info{
                    flex-grow: 1;
                    input{
                        width: 80%;
                        display: block;
                        border: 1px #ddd solid;
                    }
                    textarea.reason{
                        width: 100%;
                        height: 80px;
                    }
                }
                button{
                    padding: 7px 20px;
                    background: #fff;
                    border: 1px #ddd solid;
                    margin-right: 15px;
                    &.ok{
                        background: #0CB25E;
                        border: 1px #0CB25E solid;
                        color: #fff;
                    }
                }
            }
        }
    }
}
.icon-home:before {
    content: "\e63b";
}
.icon-share:before {
    content: "\e67e";
}
.icon-report-sign:before{
    content: "\e64f";
}
.icon-checked:before {
    content: "\e61e";
}
</style>



// WEBPACK FOOTER //
// src/components/moreTab.vue